import { useEffect, useState } from 'react';

const useOutOfFocusNotification = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
  return { isVisible };
};
export default useOutOfFocusNotification;
